export const WHATSAPP_URL = 'https://wa.me/447724556943';
export const INSTAGRAM_URL = 'https://www.instagram.com/olympiq_app/';
export const CONTACT_EMAIL = 'mailto:hello@olympiq.co.uk';
export const PRIVACY_POLICY_URL = 'https://content.olympiq.co.uk/documents/Olympiq_Privacy_Policy.pdf';
export const COOKIE_POLICY_URL = 'https://content.olympiq.co.uk/documents/Olympiq_Cookie_Policy.pdf';
